import BaseRouter from 'commons/routers/Base';
import SettingsLayoutView from '../views/settings/SettingsLayout.js';
import Log from 'lib/log';
const log = Log('admin-manager/settings-router');

module.exports = BaseRouter.extend({
    routes: {
        'settings': 'settings',
        'settings/defaultPayrollItems': 'defaultPayrollItems'
    },

    titles: {
        'settings': 'Settings',
        'settings/defaultPayrollItems': 'Default Payroll Items'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {log: log});
        BaseRouter.prototype.initialize.apply(this, [this.options]);
    },

    settings: function() {
        this.navigate('settings/defaultPayrollItems', {
            trigger: true,
            replace: true
        });
    },

    defaultPayrollItems: function() {
        this.layout = new SettingsLayoutView({
            tab: 'defaultPayrollItems',
            el:  this.options.el
        });
        this.layout.renderContent({collection: app.payrollItems});
        this.layout.hideLoader();
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/routers/Settings.js